import React, { Component } from 'react';
import { detectLangSlug, mapOldRoute, normalizeLocalizedPath } from '../utils/route_utils';

/**
 * Handles redirects from old URLs to new language-prefixed URLs.
 * Also handles root '/' redirect to detected language.
 */
class LangRedirect extends Component {
  componentDidMount() {
    const path = window.location.pathname;
    const query = window.location.search;
    const hash = window.location.hash;
    const slug = detectLangSlug();

    const normalizedPath = normalizeLocalizedPath(path);
    if (normalizedPath !== null && normalizedPath !== path) {
      window.location.replace(normalizedPath + query + hash);
      return;
    }

    // Try to map old route
    const newRoute = mapOldRoute(path, query);
    if (newRoute !== null) {
      window.location.replace('/' + slug + newRoute);
      return;
    }

    // Default: redirect to home in detected language
    window.location.replace('/' + slug + '/');
  }

  render() {
    return null;
  }
}

export default LangRedirect;
